// ───────────────────────────────────
// PROJECTS LIST RESPONSE MAPPERS
// ───────────────────────────────────

import { IqeProject } from '../../interfaces/ui';
import {
  SaveProjectResponseData,
  IqeProjectsApiResponse,
} from '../../interfaces/api/responses/saveProject.response';

import { toUiProjectStatus, toTestRuns } from '../sharedDto/status.dto';
import { sortRunsByDateDescending } from '../../utils';

// Maps fetched IQE projects API response for given APM number to
export function toIqeProjectsDomain(
  responseData: IqeProjectsApiResponse,
): IqeProject[] {
  if (!responseData) {
    return [];
  }

  const projects = responseData?.data?.projects;

  const mapped: IqeProject[] = projects.map(
    (project: SaveProjectResponseData) => ({
      id: project.projectId,
      name: project.projectName,
      appUrl: project.applicationUrl,
      loginNotRequired: false, //TODO
      environment: project.environment,
      flowId: project.flowId,
      flowName: project.flowName,
      projectMappingType:
        project.system.toLowerCase() === 'qmetry' ? 'JIRA' : 'ADO',
      transactionId: project.transactionId,
      status: toUiProjectStatus(project.status),
      userEmail: project.userEmail,
      createdAt: new Date(project.createdAt),
      mappedProject: project.mappedProject,
      mappedProjectOrg: project.organization || '',
      operation: project.operation,
      testPlanUrl: project.testPlanUrl,
      sourceCodeUrl: project.sourceCodeUrl,
      testPlanId: project.testPlanId || '',
      testPlanName: project.testPlanName,
      testSuiteId: project.testSuiteId || '',
      testSuiteName: project.testSuiteName,
      existingTestPlanId: '',
      existingTestPlanName: '',
      existingTestSuiteId: '',
      existingTestSuiteName: '',
      runs: sortRunsByDateDescending((project.runs || []).map(toTestRuns)),
    }),
  );

  console.log(
    '📊 IQE Projects Mapped:',
    mapped.map(p => ({
      name: p.name,
      runsCount: p.runs?.length || 0,
      runs: p.runs,
    })),
  );

  return mapped;
}
